import { render, staticRenderFns } from "./VEmployerEmployeesTemplateSummary.vue?vue&type=template&id=86d59738&scoped=true&lang=pug"
import script from "./VEmployerEmployeesTemplateSummary.vue?vue&type=script&lang=ts"
export * from "./VEmployerEmployeesTemplateSummary.vue?vue&type=script&lang=ts"
import style0 from "./VEmployerEmployeesTemplateSummary.vue?vue&type=style&index=0&id=86d59738&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86d59738",
  null
  
)

/* custom blocks */
import block0 from "./EmployerEmployeesTemplateSummary.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Frunner%2Fwork%2Fcompliance-nationbetter-uk%2Fcompliance-nationbetter-uk%2Fsrc%2Fmodules%2FEmployees%2FTemplate%2Fviews%2FSummary%2FVEmployerEmployeesTemplateSummary.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports